export const timeOptions = Array.from({ length: 48 }, (_, i) => {
    const hour = Math.floor(i / 2);
    const minute = (i % 2) * 30;
    return {
        _id: String(i),
        name: `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`,
    }
});

export const formatDate = (createdAt: string | Date) => {
    const date = createdAt instanceof Date ? createdAt : new Date(createdAt);
    return date.toLocaleDateString('en-CA', { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric" });
};

export const validateEmail = (email?: string) => {
    if (!email) return false;
    return emailRegex.test(email);
};

export const groupTimeSlots = (timeSlots: string[]) => {
    const groups: string[] = [];
    let group: string[] = [];
    for (let i = 0; i < timeSlots.length; i++) {
        if (i === 0) {
            group.push(timeSlots[i]);
            continue;
        }
        const prevTime = timeSlots[i - 1];
        const currentTime = timeSlots[i];
        const prevHour = Number(prevTime.split(':')[0]);
        const currentHour = Number(currentTime.split(':')[0]);
        if (currentHour - prevHour > 1) {
            groups.push(group.join(' - '));
            group = [currentTime];
        } else {
            group.push(currentTime);
        }
    }
    groups.push(group.join(' - '));
    return groups;
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const websiteRegex = /^(http|https):\/\/[^ "]+$/;